export default (cbyoValue: number, minMachinePrice: number) => {
  const cbyoNumber = Math.ceil(cbyoValue);
  return cbyoNumber < minMachinePrice * 1.5
    ? Math.round(Math.max(cbyoNumber * 0.5, 1000))
    : minMachinePrice;
};
